module.exports = __webpack_public_path__ + "img/menu-close.80d2f3e3.svg";